import * as React from "react";
import { Tag } from "@stenajs-webui/elements";
import { unreachable } from "@/lib/unreachable";
import { startCase } from "lodash";
import { Box } from "@stenajs-webui/core";
import { HeadAgreementStatusCode } from "@/gql/graphql";

interface Props {
  statusCode: HeadAgreementStatusCode;
  size?: "small" | "medium";
  labelToLowerCase?: boolean;
}

const getChipVariantByStatusCode = (statusCode: HeadAgreementStatusCode) => {
  switch (statusCode) {
    case HeadAgreementStatusCode.Active:
      return "success";
    case HeadAgreementStatusCode.Offered:
      return "success";
    case HeadAgreementStatusCode.Pending:
      return "warning";
    case HeadAgreementStatusCode.Void:
      return "passive";
    default:
      return unreachable(statusCode);
  }
};

export const HeadAgreementStatusCodeChip: React.FC<Props> = ({
  statusCode,
  size,
  labelToLowerCase = false,
}) => {
  const label = labelToLowerCase
    ? startCase(statusCode.toLowerCase())
    : statusCode.toUpperCase();

  return (
    <Box style={{ margin: "auto 0" }}>
      <Tag
        variant={getChipVariantByStatusCode(statusCode)}
        label={label}
        size={size}
        className="header-agreement-status-code-chip"
      />
    </Box>
  );
};
